 import styled from 'styled-components'

 export const Root = styled.div`
   position: fixed;
   z-index: 100;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   background: rgba(67, 67, 74, 0.75);
   display: flex;
   justify-content: center;
   align-items: flex-start;
   padding: 120px 0;
 `

 export const ModalContent = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction:  column;
   width: 470px;
   padding-bottom: 40px;
   background: #fff;
 `

 export const ModalHeader = styled.div`
   width: 470px;
   padding: 12px;
   display: flex;
   justify-content: flex-end;
   align-items: center;
   box-sizing: border-box;
   & .SVGInline {
      cursor: pointer;
      border-radius: 50%;
      height: 32px;
      width: 32px;
      text-align: center;
      vertical-align: middle;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.33s ease-in;
      &:hover {
        background: #eee;
      }
   }
 `
